module.exports = __webpack_public_path__ + "static/media/cookies.a2d05df5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cookies.svg
// module id = 746
// module chunks = 0